/* eslint-disable max-len */

import type { FC } from 'react';
import React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const TestSaveIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M9 5C9 4.44772 9.44771 4 10 4H18C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6H17.4546V11.3986L19.866 15.5739C19.9538 15.726 20 15.8985 20 16.074V17C20 17.5523 19.5523 18 19 18H9.04251L6.73235 22H13C13.5523 22 14 22.4477 14 23C14 23.5523 13.5523 24 13 24H6.73235C5.19262 24 4.23039 22.3331 5.00045 20.9998L10.5455 11.3986V6H10C9.44772 6 9 5.55228 9 5ZM12.5455 6H15.4546V11.3986C15.4546 11.7498 15.547 12.0948 15.7227 12.3989L17.8024 16H10.1976L12.2774 12.3989C12.453 12.0948 12.5455 11.7498 12.5455 11.3986V6Z"
        fillRule="evenodd"
      />
      <path d="M22 18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V22H28C28.5523 22 29 22.4477 29 23C29 23.5523 28.5523 24 28 24H24V28C24 28.5523 23.5523 29 23 29C22.4477 29 22 28.5523 22 28V24H18C17.4477 24 17 23.5523 17 23C17 22.4477 17.4477 22 18 22H22V18Z" />
    </BaseIcon>
  );
};
